import React from 'react';
import { Link } from 'react-router-dom';
import { useOsTheme, ThemeToggle } from '../os3/theme';
import { OsFooter } from '../os3/OsFooter';

/* Toast-style split auth layout: full-height image left, login right,
   with theme toggle + accessibility footer on every access screen. */
export const AuthShell = ({ image, eyebrow, title, sub, links = [], dark = false, children, testId = 'auth-shell' }) => {
  const [theme, setTheme] = useOsTheme();
  const isEs = (localStorage.getItem('kitxens-lang') || 'en') === 'es';
  return (
    <div className={`min-h-screen flex os3-scope ${dark ? 'bg-[#0B0D12]' : 'bg-[#FAFAF8]'}`} data-testid={testId}>
      <aside className="hidden lg:block lg:w-[46%] xl:w-1/2 relative overflow-hidden" aria-hidden>
        <img src={image} alt="" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/15 to-black/40" />
        <div className="absolute bottom-12 left-10 right-12 max-w-lg">
          <p className="inline-flex items-center rounded-full bg-[#F77F11] text-white text-[10.5px] tracking-[0.2em] uppercase font-bold px-3.5 py-1.5">{eyebrow}</p>
          <p className="mt-4 text-3xl xl:text-4xl font-bold text-white leading-tight drop-shadow-lg">{title}</p>
          <p className="mt-3 text-[14px] text-white/85 leading-relaxed drop-shadow">{sub}</p>
        </div>
      </aside>
      <main className="flex-1 flex flex-col items-center justify-start px-6 pt-24 pb-10 lg:pt-28 lg:pb-12 relative">
        <div className="absolute top-20 right-6 z-30" data-testid="auth-theme-toggle-wrap">
          <ThemeToggle theme={theme} setTheme={setTheme} isEs={isEs} />
        </div>
        <div className={`lg:hidden mb-5 inline-flex items-center rounded-full text-[10.5px] tracking-[0.2em] uppercase font-bold px-3.5 py-1.5 ${dark ? 'bg-[#F77F11]/15 text-[#FF9B4A]' : 'bg-orange-100 text-[#d8651a]'}`}>
          {eyebrow}
        </div>
        {children}
        {links.length > 0 && (
          <div className="mt-8 space-y-3.5 text-center max-w-2xl w-full" data-testid="auth-switch-links">
            {links.map((row, i) => (
              <div key={i} className="flex flex-wrap items-center justify-center gap-x-3 gap-y-2 text-[14.5px] leading-relaxed">
                {row.map((l, j) => (
                  <React.Fragment key={l.href + l.label}>
                    {j > 0 && <span className={`hidden sm:inline select-none ${dark ? 'text-neutral-600' : 'text-neutral-300'}`}>|</span>}
                    <span className={dark ? 'text-neutral-300' : 'text-neutral-600'}>
                      {l.q}{' '}
                      <Link to={l.href} className="text-[#F77F11] hover:text-[#d8651a] font-bold hover:underline underline-offset-4">{l.label}</Link>
                    </span>
                  </React.Fragment>
                ))}
              </div>
            ))}
          </div>
        )}
        <OsFooter isEs={isEs} showSocials={false} />
      </main>
    </div>
  );
};
